import { Link } from 'react-router';

import { UI_TEXT } from '../constants';

import { APP_ROUTES } from '@/constants/routes';

export const AppFooter = () => {
  return (
    <div className="mt-auto flex flex-col items-center justify-center border-t border-silver py-40">
      <div className="text-sm text-dark-gray">{UI_TEXT.COPYRIGHT}</div>
      <div className="text-sm text-dark-gray">
        <Link to={APP_ROUTES.TERMS}>{UI_TEXT.TERMS_TEXT}</Link> |{' '}
        {UI_TEXT.POLICY_TEXT}
      </div>
    </div>
  );
};
